__turbopack_context__.v({
  "backdrop": "SlidingModal-module__uFC8oW__backdrop",
  "closeButton": "SlidingModal-module__uFC8oW__closeButton",
  "container": "SlidingModal-module__uFC8oW__container",
  "darkBlue": "SlidingModal-module__uFC8oW__darkBlue",
  "fixedSlideAmount": "SlidingModal-module__uFC8oW__fixedSlideAmount",
  "header": "SlidingModal-module__uFC8oW__header",
  "modalContent": "SlidingModal-module__uFC8oW__modalContent",
  "scrollableContent": "SlidingModal-module__uFC8oW__scrollableContent",
  "visible": "SlidingModal-module__uFC8oW__visible",
});
